import React from "react";

import { HStack, Input, SpinnerButton, VStack } from "~/native-ui";
import { setCredentials } from "~/actions/actions";
import { authenticate } from "~/rx/authenticate";
import { connect } from '~/redux/connect'

import {
    getAuthResult, getCredentials,
    getTooltipsActive
} from "~/stateGetter";



class LoginForm extends React.PureComponent {
    state = {
        password: ""
    }
    
    submit = (e) => {
        e.preventDefault();
        const { authenticate, username, password, } = this.props;
        authenticate(username, password);
    }

    setPassword = (password) => {
        this.setState({ password });
        this.props.setCredentials(this.props.username, password);
    }

    render() {
        let { setCredentials, authenticating, username, password, trans, ...others } = this.props;
        const css = {}

        return (
            <form
                onSubmit={this.submit}
            >
                <VStack space={4}>
                    <Input disabled={authenticating} onSubmitEditing={this.submit} value={username} placeholder={trans('username')} onChange={(val) => setCredentials(val, password)} />
                    <Input disabled={authenticating} onSubmitEditing={this.submit} type="password" value={this.state.password} placeholder={trans('password')} onChange={ this.setPassword } />
                    <HStack>
                        <SpinnerButton
                            disabled={authenticating}
                            icon={authenticating ? 'spinning' : ''}
                            onClick={this.submit}
                            label={trans('login')}
                            type="submit"
                            variant="solid"
                            paddingLeft="4"
                            paddingRight="4"
                            _stack={{ space: "2" }}
                            primary
                            raised
                        />
                    </HStack>
                </VStack>
            </form>
        )
    }
};

const RXLoginForm = connect((state) => {
    let authResult = getAuthResult(state),
        commonProps = {
            ...getCredentials(state),
            authResult,
            auth: authResult.value,
            tooltipsActive: getTooltipsActive(state),
        };

    return {
        ...commonProps,
        ...getCredentials(state)
    };

}, (dispatch) => {
    return {
        setCredentials: (username, password) => dispatch(setCredentials(username, password)),
        authenticate: (username, password) => dispatch(authenticate({username, password})),
    }
}, (props, { ...otherDispatchers }, ownProps) => {
    let { auth, ...otherProps } = props;


    if(!auth) {
        return {
            authenticating: (props.authResult.started_at && !props.authResult.finished_at) || false,
            ...props,
            ...otherDispatchers,
        }
    }


    return {
        ...ownProps, ...otherProps, ...otherDispatchers,
        auth
    }
})(LoginForm);

export { RXLoginForm as LoginForm };